import styles from './checkbox.module.scss';

type CheckboxProps = React.DetailedHTMLProps<React.InputHTMLAttributes<HTMLInputElement>, HTMLInputElement> & {
  label?: string;
};
export const Checkbox = ({ id, label, children, ...props }: CheckboxProps) => {
  return (
    <div className={styles.checkbox}>
      <input className={styles.box} type="checkbox" id={id} {...props} />
      <label className={styles.label} htmlFor={id}>
        {label ?? children}
      </label>
    </div>
  );
};
